var exports = {
  "Qq": "ChannelReplyBar.module__text___SWg5V0",
  "Y_": "ChannelReplyBar.module__replyTargetButton___SWg5V0",
  "fh": "ChannelReplyBar.module__authorName___SWg5V0",
  "ne": "ChannelReplyBar.module__controls___SWg5V0",
  "xS": "ChannelReplyBar.module__mentionToggle___SWg5V0",
  "If": "ChannelReplyBar.module__mentionToggleOn___SWg5V0",
  "G9": "ChannelReplyBar.module__mentionToggleOff___SWg5V0",
  "mM": "ChannelReplyBar.module__mentionIcon___SWg5V0",
  "b": "ChannelReplyBar.module__closeButton___SWg5V0",
  "ut": "ChannelReplyBar.module__closeIcon___SWg5V0",
};

module.exports = exports;
